// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--2zX3u","text":"contact-module--text--qzJTc","email":"contact-module--email--13V0_"};